module.exports = __webpack_public_path__ + "static/img/19.30ad0fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/19.png
// module id = saLL
// module chunks = 0